
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/set-up-inheritance",
      function () {
        return require("private-next-pages/set-up-inheritance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/set-up-inheritance"])
      });
    }
  